<style lang="scss" scoped>
    .table {
        width: 100%;
        border-spacing: 0px 10px;
        &:before {
            display: none !important;
        }
    }
    /deep/ .listTable table{
        width: 100% !important;
    }
    /deep/ .listTable table tr th{
        text-align: center !important;
    }
    /deep/ .listTable table tr td{
        text-align: center !important;
    }
</style>
<template>
    <div>
        <div class="update_wrap">
            <span>刷新时间: {{lodeTime}}</span>
            <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
        </div>
        <Table :columns="tableColumns" :data="dataList" class="listTable m-t-10"></Table>
        <div class="textRight m-t-10">
            <span class="fLeft lh32">功率因数趋势</span>
            <RadioGroup v-model="day" @on-change="getChart" type="button">
                <Radio label="today">今日</Radio>
                <Radio label="yesterday">昨日</Radio>
            </RadioGroup>
        </div>
        <line-chart class="m-t-10" :id="'line-chart-0'" :height="'240px'" :y="lineData.y" :x="lineData.x" :dateUnit="'year'" :colorObj="colorObj"></line-chart>
        <div class="m-t-10">
            <span>功率因数对比</span>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr>
                <th>
                    <span class="ivu-table-cell percent50" style="float: left">总相最高功率因数</span>
                    <span class="ivu-table-cell percent50">总相最低功率因数</span>
                </th>
            </tr>
            <tr>
                <th>
                    <span class="ivu-table-cell percent50" style="float: left">{{statistics.maxValue}}</span>
                    <span class="ivu-table-cell percent50">{{statistics.minValue}}</span>
                </th>
            </tr>
        </table>
    </div>
</template>
<script>
    import lineChart from '@/components/line.vue';
    import {getDate} from '@/assets/js/index.js';
// 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'wit-electric-voltage',
        props: {
            id: ''
        },
        data() {
            return {
                day: 'today',
                lineData: {
                    x: [],
                    y: [],
                    // markArea: []
                },
                loadValue: {},
                lodeTime: '',
                statistics: {},
                colorObj:{},
                tableColumns: [],
                dataList: [],
                loginData: {},
            };
        },
        mounted() {
            this.getList();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
             //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
            refresh() {
                this.lodeTime = getDate(new Date().getTime(), 'year');
                this.getTable();
            },
            getList() {
                this.refresh();
                this.getTable();
                this.getChart();
                this.getDetail();
            },
            getChart() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/graph/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'gl',
                            date: this.day
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            let arrX = [], arrY = {}, index = 0;
                            for (let item in res.data.data) {
                                let obj = res.data.data[item];
                                this.colorObj[item] = obj[0].pointTypeCode
                                for (let y = 0; y < obj.length; y++) {
                                    if (index === 0) arrX.push(obj[y]['time'].substring(0,obj[y]['time'].length-2) + "00"); //秒数置为“00”
                                    if (arrY[item] && arrY[item].length) {
                                        arrY[item].push(obj[y]['value'])
                                    } else {
                                        arrY[item] = [obj[y]['value']];
                                    }
                                }
                                if (arrX.length) index = 1;
                            }
                            this.lineData['x'] = arrX;
                            this.lineData['y'] = arrY;
                            // this.getOffline(arrX,arrY);
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getTable() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/pointNowValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'gl',
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            let arr=[],arr1=[],obj = {};
                            res.data.data.map((value,index) => {
                                arr.push({
                                    title: value.pointName+value.unit,
                                    key: `value${index}`,
                                    width: '100%',
                                })
                                obj[`value${index}`] = value.value;
                            })
                            arr1.push(obj);
                            this.tableColumns = arr;
                            this.dataList = arr1;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getOffline(arrX,arrY) {
                let timeType,arr={};
                if(this.day == 'today'){
                    timeType = null
                }else{
                    timeType = this.day
                }
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/off_line/device_part`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'gl',
                            tId: this.id,
                            cId: JSON.parse(localStorage.getItem('loginData')).orgId, //单位ID
                            date: timeType,
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            arr.data = [];
                            res.data.data.forEach(function(value) {
                                let num = 0;
                                for (var index in value){
                                    if(arrX.indexOf(value[index].xAxis) > -1){
                                        num += 1;
                                        if(num == 2){
                                            arr.data.push(value);
                                        }
                                    }
                                }
                            });
                            this.lineData['x'] = arrX;
                            this.lineData['y'] = arrY;
                            this.lineData['markArea'] = arr;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getDetail() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/loadValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'gl',
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            this.statistics = res.data.data[0];
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
        }
        ,
        watch: {
            id() {
                this.getList()
            }
        },
        components: {
            lineChart
        }
    }
    ;
</script>


// WEBPACK FOOTER //
// src/components/wit-electric-monitor/wit-electric-rate.vue